import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Founder = () => {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -50px 0px' }
    );

    document.querySelectorAll('.reveal-on-scroll, .stat-card-enhanced, .vm-card-enhanced, .quote-card-enhanced').forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <>
      {/* Hero Section – Enhanced */}
      <div className="founder-hero-enhanced">
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="hero-content-inner">
            <span className="hero-badge">INSPIRING LEADERSHIP</span>
            <h1 className="hero-title-main">
              Meet Our Founder
            </h1>
            <p className="hero-subtitle-main">
              The visionary force behind AALI GROUP’s extraordinary journey across industries
            </p>
            <div className="hero-cta-group">
              <Link to="/contact" className="btn-primary">Connect with us</Link>
              <a href="#vision-mission" className="btn-outline-light">Discover his vision →</a>
            </div>
          </div>
        </div>
        <div className="hero-wave-bottom">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120">
            <path fill="#FFFFFF" fillOpacity="1" d="M0,64L80,58.7C160,53,320,43,480,48C640,53,800,75,960,80C1120,85,1280,75,1360,69.3L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
          </svg>
        </div>
      </div>

      {/* Profile + Bio + Stats Section */}
      <div className="founder-profile-enhanced">
        <div className="container">
          <div className="profile-grid-enhanced">
            <div className="profile-image-col reveal-on-scroll">
              <div className="image-wrapper">
                <img src="/assets/opt/ceo.webp" alt="Azagar Ali Shaik" />
                <div className="image-badge">10+ Years of Excellence</div>
              </div>
            </div>
            <div className="profile-bio-col reveal-on-scroll">
              <span className="section-tag">THE LEADER</span>
              <h2>Azagar Ali Shaik</h2>
              <div className="founder-title-modern">Founder & Chief Executive Officer</div>
              <p className="bio-text">
                Visionary entrepreneur with over <strong>10 years of experience</strong> building successful businesses 
                across diverse sectors. His leadership and strategic vision have been instrumental in establishing 
                AALI GROUP as a respected conglomerate, spanning <strong>technology, infrastructure, media, luxury retail, 
                and social impact initiatives</strong>.
              </p>
              <div className="bio-stats-mini">
                <div className="mini-stat">
                  <span className="stat-number">10+</span>
                  <span className="stat-label">Years Experience</span>
                </div>
                <div className="mini-stat">
                  <span className="stat-number">3+</span>
                  <span className="stat-label">Industries</span>
                </div>
                <div className="mini-stat">
                  <span className="stat-number">300+</span>
                  <span className="stat-label">Jobs Created</span>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>

      {/* Vision & Mission – Enhanced Cards */}
      <div className="vision-mission-enhanced" id="vision-mission">
        <div className="container">
          <div className="section-header-center">
            <span className="section-tag">OUR COMPASS</span>
            <h2>Vision & Mission</h2>
            <p>Guiding principles that shape every decision and drive our growth</p>
          </div>
          <div className="vision-mission-grid-enhanced">
            <div className="vm-card-enhanced reveal-on-scroll">
              <div className="vm-icon-enhanced">🎯</div>
              <h3>Our Vision</h3>
              <p>
                To be a globally recognized conglomerate that creates sustainable value across diverse industries 
                while making a meaningful difference in the communities we serve. We envision AALI GROUP as a beacon 
                of innovation, excellence, and social responsibility.
              </p>
            </div>
            <div className="vm-card-enhanced reveal-on-scroll">
              <div className="vm-icon-enhanced">🚀</div>
              <h3>Our Mission</h3>
              <p>
                To deliver exceptional products and services that exceed expectations, foster innovation that drives 
                progress, and create opportunities that empower people. We are committed to building businesses that 
                not only succeed commercially but also contribute positively to society.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Leadership Philosophy + Quote */}
      <div className="leadership-philosophy">
        <div className="container">
          <div className="philosophy-grid-enhanced">
            <div className="philosophy-text reveal-on-scroll">
              <h2>Leadership that <span className="highlight">Inspires Trust</span></h2>
              <p>
                Under the visionary leadership of Azagar Ali Shaik, AALI GROUP has grown into a diversified conglomerate 
                spanning multiple industries. His strategic vision and commitment to excellence have been instrumental 
                in building a business empire rooted in innovation, integrity, and social responsibility.
              </p>
              <p>
                With a commitment to transparency, ethical business practices, and stakeholder value creation, 
                AALI GROUP continues to set benchmarks for corporate excellence and community impact across all sectors 
                of operation.
              </p>
              
            </div>
            <div className="quote-card-enhanced reveal-on-scroll">
              <div className="quote-icon">“</div>
              <p className="quote-text">
                Success is not just about building businesses; it's about empowering people, 
                uplifting communities, and leaving a legacy of positive impact.
              </p>
              <div className="quote-author">
                <img src="/assets/opt/ceo.webp" alt="Azagar Ali Shaik" className="author-img" />
                <div>
                  <strong>Azagar Ali Shaik</strong>
                  <span>Founder & CEO, AALI GROUP</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="founder-cta">
        <div className="container">
          <div className="cta-content-enhanced">
            <h2>Be Part of Our Story</h2>
            <p>Join us in shaping a future driven by innovation, integrity, and impact.</p>
            <div className="cta-buttons-enhanced">
              <Link to="/contact" className="btn-primary btn-outline-light">Get in touch</Link>
              <Link to="/careers" className="btn-outline-light">Explore careers</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Founder;